export default {
  getFeaturesForPoint: state => {
    return state.features.toJS().filter(f => f.geometry.type === "Point");
  },
  getFeaturesForPolygon: state => {
    return state.features.toJS().filter(f => f.geometry.type === "Polygon");
  },
}
